import { asyncConfirmOverlay, openOverlay } from "overlay"
import type { Folder, Media } from "luxedo-data"
import MediaUploadForm from "./MediaUpload.svelte"

export function openMediaUploadOverlay(activeFolder: Folder, postSubmit: () => void) {
	let isUploading = false

	function onComplete() {
		isUploading = false
		postSubmit()
	}

	function onStart() {
		isUploading = true
	}

	return openOverlay(MediaUploadForm, {
		heading: "",
		classOverlay: "media-overlay no-pad",
		classHeading: "no-underline no-heading",
		hideExitButton: true,
		beforeClose: async () => {
			if (isUploading)
				await asyncConfirmOverlay({
					confirmText: "Cancel Upload",
					denyText: "Continue Upload",
					prompt: [
						"Are you sure you want to close this window?",
						"Current upload will be cancelled.",
					],
					title: "Cancel Upload",
				})
		},
		props: {
			folderId: activeFolder.id,
			onComplete,
			onStart,
		},
	})
}

export function openMediaReUploadOverlay(media: Media, postSubmit?: () => void) {
	let isUploading = false

	function onComplete() {
		isUploading = false
		postSubmit?.()
	}

	function onStart() {
		isUploading = true
	}

	return openOverlay(MediaUploadForm, {
		heading: "",
		classOverlay: "media-overlay no-pad",
		classHeading: "no-underline no-heading",
		hideExitButton: true,
		beforeClose: async () => {
			if (isUploading)
				await asyncConfirmOverlay({
					confirmText: "Cancel Upload",
					denyText: "Continue Upload",
					prompt: [
						"Are you sure you want to close this window?",
						"Current upload will be cancelled.",
					],
					title: "Cancel Upload",
				})
		},
		props: {
			entryId: media.id,
			folderId: media.parent_id,
			onComplete,
			onStart,
		},
	})
}
